export enum SideEnum {
  BUY = 'BUY',
  SELL = 'SELL'
}
